<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-packagetour-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
      [checkId]="checkId">
    </app-packagetour-menutab>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-lg-6 col-12">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} paquete
          </a>
        </div>
        <div class="col-lg-6 col-12 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>) - campos web (<i
              class="fab fa-quinscape text-primary"></i>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off" class="m-b-30">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6">
                  <label>Nombre paquete<span class="required"></span></label>
                  <input type="text" id="item_description" formControlName="description" required="true"
                    class="form-control" [autofocus]
                    [ngClass]="{'parsley-error': (submitted && f['description'].errors)}">
                  <div *ngIf="submitted && f['description'].errors">
                    <small class="text-danger" *ngIf="f['description'].errors['required']">Nombre es requerido</small>
                    <small class="text-danger" *ngIf="f['description'].errors['minlength']">Nombre Muy corto</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Tipo paquete<span class="required"></span></label>
                  <select class="form-control" id="typePackageSelected" formControlName="typepackage_id" required>
                    <option value="">Seleccionar opción</option>
                    <option *ngFor="let item of typepackages" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['typepackage_id'].errors">
                    <small class="text-danger" *ngIf="f['typepackage_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Categoría paquete<span class="required"></span>
                    <button type="button" data-toggle="modal" data-target="#openExtendsCategoryPackagetour"
                    (click)="CategorypackagetourExtendsComponent.focused()"
                    class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                  </button>
                </label>
                  <select class="form-control" id="categoryPackageSelected" formControlName="packagetourcategory_id"
                    required>
                    <option value="">Seleccionar opción</option>
                    <option *ngFor="let item of packagecategories" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['packagetourcategory_id'].errors">
                    <small class="text-danger" *ngIf="f['packagetourcategory_id'].errors['required']">Campo
                      requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Ciudad<span class="required"></span></label>
                  <select class="form-control" id="citieTouristicSelected" formControlName="citietouristic_id" required>
                    <option value="">Seleccionar opción</option>
                    <option *ngFor="let item of citiestouristic" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['citietouristic_id'].errors">
                    <small class="text-danger" *ngIf="f['citietouristic_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Plantilla<span class="required"></span></label>
                  <select class="form-control" id="typePackageSelected" formControlName="templates_detailpackages_id" required>
                    <option *ngFor="let item of templates_packages" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['typepackage_id'].errors">
                    <small class="text-danger" *ngIf="f['typepackage_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox m-t-25">
                    <input type="checkbox" id="is_show_web" class="custom-control-input" formControlName="is_show_web">
                    <label class="custom-control-label p-t-3" for="is_show_web">
                      <i class="fab fa-quinscape text-primary m-r-5"></i> ¿Se muestra en la web?
                      <span data-toggle="tooltip" data-placement="right"
                        data-original-title="El paquete se muestra en la página web"><i
                          class="fas fa-info-circle f-s-14"></i></span>
                    </label>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <div class="custom-control custom-checkbox m-t-25">
                    <input type="checkbox" id="is_special_offer" class="custom-control-input"
                      formControlName="is_special_offer" (change)="changeSpecialOffer()">
                    <label class="custom-control-label p-t-3" for="is_special_offer">
                      <i class="fab fa-quinscape text-primary m-r-5"></i> ¿Es oferta especial?
                      <span data-toggle="tooltip" data-placement="right"
                        data-original-title="El paquete es una oferta especial"><i
                          class="fas fa-info-circle f-s-14"></i></span>
                    </label>
                  </div>
                </div>
                <ng-container *ngIf="item.value.is_special_offer">
                  <div class="form-group col-lg-3">
                    <label>Seleccionar oferta <span class="required"></span></label>
                    <select class="form-control" id="specialOfferSelected" formControlName="specialoffers_id">
                      <option *ngFor="let item of specialoffers" [value]="item.id">{{ item.description }}</option>
                    </select>
                  </div>
                </ng-container>
              </div>
              <div class="row">
                <div class="form-group col-lg-6 col-12">
                  <label>¿Agregar portada en PDF? </label>
                  <ng-container *ngIf="item.value.url_document != null">
                    <div class="row col-lg-12 col-12 p-0">
                      <div class="col-lg-6 col-12">
                        <a target="_blank" href="tenants/{{item.value.url_document}}"
                          class="btn btn-outline-primary pointer w-100">Portada PDF <i
                            class="far fa-file-pdf m-l-5"></i></a>
                      </div>
                      <div class="form-group col-lg-6 col-12">
                        <button (click)="removeFilePdfPortada()" class="btn btn-outline-danger pointer w-100">
                          Quitar pdf <i class="fas fa-minus-circle"></i>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="item.value.url_document == null">
                    <input id="file_pdf" type="file" (change)="onFileSelectedPdfPortada($event)"
                      accept="application/pdf" />
                  </ng-container>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-lg-12 m-t-15">
                  <label><i class="fab fa-quinscape text-primary m-r-5"></i>Descripción paquete</label>
                  <ckeditor formControlName="include"></ckeditor>
                </div>
              </div>
              <div class="row m-b-20">
                <div class="col-lg-12 m-t-10">
                  <p class="form__group__title">
                    <i class="fas fa-chevron-circle-right m-r-5"></i>Tarifas del paquete
                  </p>
                </div>
                <div class="col-lg-12">
                  <div class="row m-b-15">
                    <div class="form-group col-lg-7">
                      <div class="input-group">
                        <div class="input-group-append">
                          <div class="input-group-text">
                            <span>Tipo de precio</span>
                          </div>
                        </div>
                        <select class="form-control" id="packageTourPriceSelected"
                          formControlName="packagetourtypeprice_id" required (change)="changePackageTourPrice()">
                          <option *ngFor="let item of typepricespackage" [value]="item.id">{{ item.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="form-group col-lg-12">
                          <label for="searchTours"><i class="fas fa-info-circle m-r-5"></i> Selecionar TOURS para el
                            paquete</label>
                          <component-search-tour (selectedTourEvent)="selectedTourSearch($event)">
                          </component-search-tour>
                        </div>
                        <div class="col-lg-12">
                          <div class="table-responsive">
                            <table class="table table-hover mb-0 table-sm">
                              <thead class="thead-default">
                                <tr>
                                  <th>Nombre Tours</th>
                                  <th class="text-left">P.Corpo.</th>
                                  <th class="w-25 text-center nowrap">P. paquete
                                    <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Precio del tours en paquete"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th class="text-center">Orden</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngIf="detail_tours.length == 0">
                                  <td colspan="2"><span>No se encontraron registros</span></td>
                                </ng-container>
                                <ng-container *ngIf="detail_tours.length > 0">
                                  <tr *ngFor="let item of detail_tours; let index_ = index">
                                    <td class="nowrap w-xs-auto">{{item.description}}</td>
                                    <td class="nowrap w-xs-auto text-left">
                                      {{toolsService.momeySol()}}{{item.price_corporate}}
                                    </td>
                                    <td class="w-25 w-xs-auto">
                                      <div class="input-group">
                                        <div class="input-group-prepend hide-xs">
                                          <span class="input-group-text f-s-11">{{toolsService.momeySol()}}</span>
                                        </div>
                                        <input type="text" id="tour_price_package{{index_}}"
                                          class="form-control form-control-xs text-center"
                                          value="{{item.price_package}}"
                                          (keyup)="changeTourPricePackage($event.target, index_)" numeric decimals="2"
                                          onclick="click_input(this)">
                                      </div>
                                    </td>
                                    <td class="text-center">
                                      <input type="text" id="tour_position_package{{index_}}" placeholder="Pos"
                                        class="form-control form-control-xs text-center" value="{{item.position}}"
                                        (keyup)="changeTourPositionPackage($event.target, index_)" numeric
                                        onclick="click_input(this)">
                                    </td>
                                    <td>
                                      <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                        (click)="removeTourPackage(item.id, index_)"></i>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                              <ng-container *ngIf="detail_tours.length > 0">
                                <tfoot class="thead-default">
                                  <tr>
                                    <th class="text-center text-primary f-s-13">
                                      TOTALES {{toolsService.momeySol()}}
                                    </th>
                                    <th class="text-left">
                                      {{this.total_tour_corporate}}
                                    </th>
                                    <th class="text-center text-primary">
                                      <span class="f-s-14"> {{this.total_tour}}</span>
                                    </th>
                                    <th colspan="2">
                                      <div class="input-group">
                                        <div class="input-group-prepend hide-xs">
                                          <span class="input-group-text f-s-11">G.</span>
                                        </div>
                                        <input type="text" class="form-control form-control-xs f-s-12 text-center"
                                          value="{{(this.total_tour - this.total_tour_corporate).toFixed(2)}}" disabled>
                                      </div>
                                    </th>
                                  </tr>
                                </tfoot>
                              </ng-container>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ng-container
                      *ngIf="item.value.packagetourtypeprice_id == package_typeprice_tourandhotel || item.value.packagetourtypeprice_id == package_typeprice_multicity">
                      <!-- informacion servicios -->
                      <!-- <div class="col-lg-6 m-t-15">
                        <div class="row">
                          <div class="form-group col-lg-12 col-12 m-b-10">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="is_services" class="custom-control-input"
                                formControlName="is_services" (change)="includeServices()">
                              <label class="custom-control-label p-t-3" for="is_services">
                                <ng-container *ngIf="item.value.is_services">
                                  <i class="fas fa-info-circle m-r-5"></i> Servicios para el
                                  paquete
                                </ng-container>
                                <ng-container *ngIf="!item.value.is_services">
                                  ¿Se incluyen servicios?
                                </ng-container>
                              </label>
                            </div>
                          </div>
                          <ng-container *ngIf="item.value.is_services">
                            <div class="col-lg-12">
                              <div class="form-group col-lg-12 p-0">
                                <component-search-product [typeProduct]="2" [controlStock]="false"
                                  (selectedProductEvent)="selectedServiceSearch($event)">
                                </component-search-product>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-hover mb-0 table-sm">
                                  <thead class="thead-default">
                                    <tr>
                                      <th>Nombre </th>
                                      <th class="text-center">Cantidad</th>
                                      <th class="text-center">Precio</th>
                                      <th class="text-center">Subtotal</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <ng-container *ngIf="detail_services.length == 0">
                                      <td colspan="2"><span>No se encontraron registros</span></td>
                                    </ng-container>
                                    <ng-container *ngIf="detail_services.length > 0">
                                      <tr *ngFor="let item of detail_services; let index_ = index">
                                        <td class="nowrap w-xs-auto">{{item.description}}</td>
                                        <td>
                                          <input type="text" id="service_quantity{{index_}}"
                                            class="form-control form-control-xs text-center" value="{{item.quantity}}"
                                            (keyup)="changeServiceQuantityPackage($event.target, index_)" numeric
                                            decimals="2" onclick="click_input(this)">
                                        </td>
                                        <td>
                                          <div class="input-group">
                                            <div class="input-group-prepend">
                                              <span class="input-group-text f-s-11">{{toolsService.momeySol()}}</span>
                                            </div>
                                            <input type="text" id="service_price{{index_}}"
                                              class="form-control form-control-xs text-center" value="{{item.price}}"
                                              (keyup)="changeServicePricePackage($event.target, index_)" numeric
                                              decimals="2" onclick="click_input(this)">
                                          </div>
                                        </td>
                                        <td class="text-center">
                                          {{toolsService.momeySol()}}{{item.subtotal}}
                                        </td>
                                        <td>
                                          <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                            (click)="removeServicePackage(item.id, index_)"></i>
                                        </td>
                                      </tr>
                                    </ng-container>
                                  </tbody>
                                  <ng-container *ngIf="detail_services.length > 0">
                                    <tfoot class="thead-default">
                                      <tr>
                                        <th class="text-right text-primary f-s-13" colspan="3">
                                          TOTAL {{toolsService.momeySol()}}
                                        </th>
                                        <th class="text-center">
                                          <span class="text-primary bold f-s-14">{{(total_service).toFixed(2)}}</span>

                                        </th>
                                        <th></th>
                                      </tr>
                                    </tfoot>
                                  </ng-container>
                                </table>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div> -->
                      <!-- informacion vuelo -->
                      <!-- <div class="col-lg-6 m-t-15">
                        <div class="row">
                          <div class="form-group col-lg-12 col-12 m-b-10">
                            <div class="custom-control custom-checkbox">
                              <input type="checkbox" id="include_flight" class="custom-control-input"
                                formControlName="include_flight" (change)="includeFlight()">
                              <label class="custom-control-label p-t-3" for="include_flight">
                                ¿Incluye vuelo?
                              </label>
                            </div>
                          </div>
                          <ng-container *ngIf="item.value.include_flight">
                            <div class="form-group col-lg-5 col-12">
                              <label>Costo x persona <span class="required"></span></label>
                              <input type="text" id="total_flight" class="form-control" [(ngModel)]="total_flight" numeric decimals="2"
                                onclick="click_input(this)" (keyup)="changeTotalFLight($event.target)" [ngModelOptions]="{standalone: true}">
                            </div>
                            <div class="form-group col-lg-7 col-12">
                              <label>Detalle Equipaje<span class="required"></span></label>
                              <input type="text" class="form-control" id="flight_baggage" formControlName="flight_baggage">
                            </div>
                            <div class="form-group col-lg-4 col-12">
                              <p class="text-left">
                                <label for="file" style="cursor: pointer" class="m-b-0 m-t-10"><i
                                    class="fas fa-upload"></i>
                                  Subir itinerario
                                  <input id="file" type="file" (change)="onFileSelected($event)"
                                    accept=".png, .jpg, .jpeg" style="visibility: hidden;">
                                </label>
                              </p>
                            </div>
                            <div class="form-group col-lg-8 col-12">
                              <ng-container *ngIf="item.value.url_flight != null">
                                <img height="150" class="w-100" src="tenants/{{item.value.url_flight}}" alt="Preview">
                              </ng-container>
                              <ng-container *ngIf="item.value.url_flight == null">
                                <ng-container *ngIf="imageUrl != null">
                                  <img height="150" class="w-100" [src]="imageUrl" alt="Preview">
                                </ng-container>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                      </div> -->
                    </ng-container>

                    <div class="col-lg-12 m-t-20"
                      *ngIf="item.value.packagetourtypeprice_id == package_typeprice_tourandhotel">
                      <div class="row">
                        <div class="form-group col-lg-7">
                          <label for="searchTours"><i class="fas fa-info-circle m-r-5"></i> Selecionar HOTEL para el
                            paquete</label>
                          <component-search-hotel (selectedHotelEvent)="selectedHotelSearch($event)">
                          </component-search-hotel>
                        </div>
                        <div class="col-lg-12">
                          <div class="table-responsive">
                            <table class="table table-hover mb-0 table-sm">
                              <thead class="thead-default">
                                <tr>
                                  <th class="w-20">Nombre Hotel</th>
                                  <th class="w-10 text-center position-relative nowrap">
                                    N° noches<span class="required"></span>
                                  </th>
                                  <th class="w-15 text-center position-relative nowrap">P. paquete
                                    <span class="required"></span>
                                    <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Precio del hotel en paquete"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th class="w-15 text-center nowrap">
                                    + Adiccio. <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Costos adicionales"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th class="w-15 text-center nowrap">- Dscto<span data-toggle="tooltip"
                                      data-placement="right" data-original-title="Descuentos a considerar"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th class="w-35 text-right nowrap">P. FINAL
                                    <span class="f-s-9">
                                      (<ng-container *ngIf="item.value.include_flight">
                                        <span>Vuelo+</span>
                                      </ng-container>
                                      Hotel+Tours+Serv.)
                                    </span>
                                    <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Precio final x persona calculado"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th>isWeb
                                    <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Hotel seleccionado por defecto para el paquete en la Web"><i
                                        class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th>TopPdf
                                    <span data-toggle="tooltip" data-placement="right"
                                      data-original-title="Hotel destacado para el paquete en el PDF">
                                      <i class="fas fa-info-circle m-l-5"></i></span>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngIf="detail_hotels.length == 0">
                                  <td colspan="2"><span>No se encontraron registros</span></td>
                                </ng-container>
                                <ng-container *ngIf="detail_hotels.length > 0">
                                  <tr *ngFor="let item of detail_hotels; let index_ = index"
                                    [ngClass]="{'text-primary bold': item.is_principal, 'is-outstanding': item.is_outstanding }">
                                    <td class="nowrap w-xs-auto">
                                      <p class="m-b-0">
                                        <i class="fas fa-external-link-alt m-r-1 pointer" (click)="showHotel(item)"
                                          data-toggle="modal" data-target="#openExtendsHotelInformation"></i>
                                        {{item.tradename}}
                                      </p>
                                      <ng-container *ngIf="item.is_principal">
                                        <p class="badge badge-info f-s-8 m-b-0 m-t-1">Principal</p>
                                      </ng-container>
                                    </td>
                                    <td class="w-10">
                                      <input type="text" id="hotel_nights{{index_}}"
                                        class="form-control form-control-xs text-center" value="{{item.nights}}"
                                        (keyup)="changeHotelNights($event.target, index_)" numeric
                                        onclick="click_input(this)">
                                    </td>
                                    <td class="w-15">
                                      <input type="text" id="hotel_price_package{{index_}}"
                                        class="form-control form-control-xs text-center" value="{{item.price_package}}"
                                        (keyup)="changeHotelPricePackage($event.target, index_)" numeric decimals="2"
                                        onclick="click_input(this)">
                                    </td>
                                    <td class="w-15">
                                      <input type="text" id="hotel_additional{{index_}}"
                                        class="form-control form-control-xs text-center text-success bold"
                                        value="{{item.additional}}"
                                        (keyup)="changeHotelAdditional($event.target, index_)" numeric decimals="2"
                                        onclick="click_input(this)">
                                    </td>
                                    <td class="w-15">
                                      <input type="text" id="hotel_discount{{index_}}"
                                        class="form-control form-control-xs text-center text-danger bold"
                                        value="{{item.discount}}" (keyup)="changeHotelDiscount($event.target, index_)"
                                        numeric decimals="2" onclick="click_input(this)">
                                    </td>
                                    <td class="w-35">
                                      <div class="input-group">
                                        <div class="input-group-prepend">
                                          <span class="input-group-text bold">{{toolsService.momeySol()}}</span>
                                        </div>
                                        <input type="text" class="form-control form-control-sm text-right bold"
                                          id="hotel_price_final_package{{index_}}" value="{{item.price_final_package}}"
                                          disabled>
                                      </div>
                                    </td>
                                    <td class="text-center">
                                      <ng-container *ngIf="item.is_principal">
                                        <input type="radio" name="is_principal" class="pointer"
                                          (change)="changePrincipalHotel(index_)" checked>
                                      </ng-container>
                                      <ng-container *ngIf="!item.is_principal">
                                        <input type="radio" name="is_principal" class="pointer"
                                          (change)="changePrincipalHotel(index_)">
                                      </ng-container>
                                    </td>
                                    <td class="text-center">
                                      <ng-container *ngIf="item.is_outstanding">
                                        <input type="checkbox" name="is_outstanding" class="pointer"
                                          (change)="changeOutstandingHotel(index_)" checked>
                                      </ng-container>
                                      <ng-container *ngIf="!item.is_outstanding">
                                        <input type="checkbox" name="is_outstanding" class="pointer"
                                          (change)="changeOutstandingHotel(index_)">
                                      </ng-container>
                                    </td>
                                    <td class="text-center">
                                      <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                        (click)="removeHotel(index_, item.tradename )"></i>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12 m-t-30"
                      *ngIf="item.value.packagetourtypeprice_id == package_typeprice_multicity">
                      <div class="row">
                        <div class="col-lg-5">
                          <label for="searchTours"><i class="fas fa-info-circle m-r-5"></i>Ciudades para el paquete
                            (mínimo 2)</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <div class="input-group-text">
                                <span>Elegir ciudad</span>
                              </div>
                            </div>
                            <select class="form-control" id="cityMultiSelected" [(ngModel)]="cityMultiSelected"
                              [ngModelOptions]="{standalone: true}">
                              <option *ngFor="let item of citiestouristic_multi" [value]="item.id">
                                {{ item.description }}</option>
                            </select>
                            <div class="input-group-append">
                              <button type="button" wire:click="addMultiHotel" (click)="addMultiCity()"
                                class="btn btn-info button-small">Agregar</button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-lg-7">
                          <label for="searchTours"><i class="fas fa-info-circle m-r-5"></i> Selecionar HOTEL para el
                            paquete</label>
                          <component-search-hotel (selectedHotelEvent)="selectedHotelSearch($event)">
                          </component-search-hotel>
                        </div>
                      </div>
                      <div class="row col-lg-12 p-0" *ngIf="detail_multicity.length > 0">
                        <ng-container *ngFor="let city of detail_multicity; let index_city_ = index">
                          <div class="col-lg-6 m-t-20">
                            <p class="m-b-5"><i class="fas fa-map-marker-alt m-r-2"></i> Hoteles para la ciudad
                              : <span class="bold text-uppercase text-success">{{city.name_city}}</span>
                              <i class="far fa-trash-alt pointer f-s-15 text-danger m-l-10"
                                (click)="removeMultiCity(index_city_, city.name_city)"></i>
                            </p>
                            <div class="col-lg-12 p-0">
                              <div class="table-responsive">
                                <table class="table table-hover mb-0 table-sm">
                                  <thead class="thead-default">
                                    <tr>
                                      <th>
                                        <span data-toggle="tooltip" data-placement="right"
                                          data-original-title="Hotel destacado para el paquete" title=""><i
                                            class="fas fa-info-circle m-l-5"></i>
                                        </span>
                                      </th>
                                      <th>Nombre Hotel</th>
                                      <th class="w-15">
                                        N° noches <span class="required"></span>
                                      </th>
                                      <th class="w-25">P. paquete
                                        <span data-toggle="tooltip" data-placement="right"
                                          data-original-title="Precio del hotel en paquete" title=""><i
                                            class="fas fa-info-circle m-l-5"></i></span>
                                      </th>
                                      <th class="w-15 text-center">
                                        + Adiccio. <span data-toggle="tooltip" data-placement="right"
                                          data-original-title="Costos adicionales" title=""><i
                                            class="fas fa-info-circle m-l-5"></i></span>
                                      </th>
                                      <th class="w-15 text-center">- Dscto<span data-toggle="tooltip"
                                          data-placement="right" data-original-title="Descuentos a considerar"
                                          title=""><i class="fas fa-info-circle m-l-5"></i></span>
                                      </th>
                                      <th>Principal</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <ng-container *ngIf="city.detail_hotels.length == 0">
                                      <td colspan="3"><span>No se encontraron registros</span></td>
                                    </ng-container>
                                    <ng-container *ngIf="city.detail_hotels.length > 0">
                                      <tr *ngFor="let item of city.detail_hotels; let index_ = index"
                                        [ngClass]="{'text-primary bold': item.is_principal, 'is-outstanding': item.is_outstanding }">
                                        <td class="text-center">
                                          <ng-container *ngIf="item.is_outstanding">
                                            <input type="checkbox" name="is_outstanding" class="pointer"
                                              (change)="changeOutstandingHotelCity(index_city_, index_)" checked>
                                          </ng-container>
                                          <ng-container *ngIf="!item.is_outstanding">
                                            <input type="checkbox" name="is_outstanding" class="pointer"
                                              (change)="changeOutstandingHotelCity(index_city_, index_)">
                                          </ng-container>
                                        </td>
                                        <td>
                                          <p class="m-b-0">
                                            {{item.tradename}}
                                          </p>
                                          <ng-container *ngIf="item.is_principal">
                                            <p class="badge badge-info f-s-8 m-b-0 m-t-1">Principal</p>
                                          </ng-container>
                                        </td>
                                        <td class="w-15">
                                          <input type="text" id="hotel_nights{{index_city_}}{{index_}}"
                                            class="form-control form-control-xs text-center" value="{{item.nights}}"
                                            (keyup)="changeHotelNightsCity($event.target, index_city_, index_)" numeric
                                            onclick="click_input(this)">
                                        </td>

                                        <td class="w-25">
                                          <input type="text" id="hotel_price_package{{index_city_}}{{index_}}"
                                            class="form-control form-control-xs text-center"
                                            value="{{item.price_package}}"
                                            (keyup)="changeHotelPricePackageCity($event.target, index_city_, index_)"
                                            numeric decimals="2" onclick="click_input(this)">
                                        </td>
                                        <td class="w-15">
                                          <input type="text" id="hotel_additional{{index_city_}}{{index_}}"
                                            class="form-control form-control-xs text-right text-success bold"
                                            value="{{item.additional}}"
                                            (keyup)="changeHotelAdditionalCity($event.target,index_city_, index_)"
                                            numeric decimals="2" onclick="click_input(this)">
                                        </td>
                                        <td class="w-15">
                                          <input type="text" id="hotel_discount{{index_city_}}{{index_}}"
                                            class="form-control form-control-xs text-right text-danger bold"
                                            value="{{item.discount}}"
                                            (keyup)="changeHotelDiscountCity($event.target, index_city_, index_)"
                                            numeric decimals="2" onclick="click_input(this)">
                                        </td>
                                        <td class="text-center">
                                          <ng-container *ngIf="item.is_principal">
                                            <input type="radio" id="is_principal{{index_city_}}{{index_}}"
                                              class="pointer" (change)="changePrincipalHotelCity(index_city_,index_)"
                                              checked>
                                          </ng-container>
                                          <ng-container *ngIf="!item.is_principal">
                                            <input type="radio" id="is_principal{{index_city_}}{{index_}}"
                                              class="pointer" (change)="changePrincipalHotelCity(index_city_,index_)">
                                          </ng-container>
                                        </td>
                                        <td class="text-center">
                                          <ng-container *ngIf="!item.is_principal">
                                            <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                              (click)="removeHotelCity(index_city_ , index_ , item.tradename )"></i>
                                          </ng-container>
                                        </td>
                                      </tr>
                                    </ng-container>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <div class="col-lg-12 m-t-25">
                        <p class="bold text-danger f-s-15">
                          <i class="fas fa-info-circle m-r-5"></i> Cálculo precio por persona :
                          {{toolsService.momeySol()}} {{total_multicity}}</p>
                      </div>
                    </div>                    
                    <div class="col-lg-12 m-t-30">
                      <div class="row">
                        <div class="col-lg-12">
                          <label><i class="fas fa-info-circle m-r-5"></i> Especificaciones del paquete</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-lg-2">
                          <label>N° mínimo pax <span data-toggle="tooltip" data-placement="right"
                              data-original-title="N° mínimo de personas para que aplique el precio"><i
                                class="fas fa-info-circle m-l-5"></i></span><span class="required"></span> </label>
                          <input type="number" id="item_min_pax" class="form-control" formControlName="min_pax">
                        </div>
                        <div class="form-group col-lg-10" *ngIf="item.value.packagetourtypeprice_id != package_typeprice_tour">
                          <label>Tipo habitación <span data-toggle="tooltip" data-placement="right"
                              data-original-title="Tipo de habitación que aplica para el paquete"><i
                                class="fas fa-info-circle m-l-5"></i></span><span class="required"></span> </label>
                          <input type="text" id="item_description_room" class="form-control"
                            formControlName="description_room" placeholder="HAB. MAT, etc">
                        </div>
                        <div class="col-lg-8 m-t-25" *ngIf="item.value.packagetourtypeprice_id == package_typeprice_tour">
                          <p class="bold text-primary f-s-15">
                            <i class="fas fa-info-circle m-r-5"></i> Cálculo TOTAL PAQUETE :
                            {{toolsService.momeySol()}} {{total_tour*item.value.min_pax}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn btns-fixeds">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  Guardar
                  <ng-container *ngIf="isEdit">
                    Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-hotel-information-extends></app-hotel-information-extends>
<app-categorypackagetour-extends (onSubmitEvent)="extendsCategoryPackagetour($event)"></app-categorypackagetour-extends>